import { useState, useCallback } from 'react';

// Custom hook to manage carbon data refresh across components
export const useCarbonDataRefresh = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  return { refreshTrigger, triggerRefresh };
};